module.exports = __webpack_public_path__ + "img/vector-bg.c96fb628.jpg";